export function initializeLocationState(value) {
    return {
        value,
        ...locationToStrings(value),
    };
}
export function reduceLocation(state, action) {
    if (action.type === 'value') {
        return {
            ...state,
            value: action.value,
            ...locationToStrings(action.value),
        };
    }
    const newState = { ...state };
    if (action.type === 'lat') {
        newState.latString = action.value;
    }
    else {
        newState.lngString = action.value;
    }
    return newState;
}
function locationToStrings(location) {
    return {
        latString: location ? String(location.lat) : '',
        lngString: location ? String(location.lng) : '',
    };
}
export function stringsToLocation({ latString, lngString, }) {
    const lat = Number.parseFloat(latString);
    const lng = Number.parseFloat(lngString);
    return !Number.isNaN(lat) && !Number.isNaN(lng) ? { lat, lng } : null;
}
//# sourceMappingURL=LocationReducer.js.map